import { render, staticRenderFns } from "./TagColor.vue?vue&type=template&id=633f538f&scoped=true"
import script from "./TagColor.vue?vue&type=script&lang=js"
export * from "./TagColor.vue?vue&type=script&lang=js"
import style0 from "./TagColor.vue?vue&type=style&index=0&id=633f538f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "633f538f",
  null
  
)

export default component.exports